import { UpdateAppointmentPriceInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateAppointmentPriceInputSchema: z.ZodType<UpdateAppointmentPriceInput> =
  z.object({
    appointment_price: z.string(),
    first_appointment_price: z.string(),
  });
